import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const SecBar = () => {
    const isIta = useSelector((state) => state.createUser.languageIta);
    return (
        <div className='myBgAcqua'>
            <div className='d-flex justify-content-center gap-3 fw-bold'>
                <Link to={"/ourservices"} className='noDecoration text-light'>{isIta?"Servizi":"Services"}</Link>
                <Link to={"/ourservices/b2bdirectcall"} className='noDecoration text-light'>{isIta?"Novità":"News"}</Link>
            </div>
        </div>
    )
}

export default SecBar